import { type FC, useMemo } from 'react';

import type { GameV1 } from '@/api/games';
import { ColorMode } from '@/components/GameItem/styled';
import type { ScGameItemPlugProps } from '@/components/GamesGrid/styled';
import type { GameItemMode } from '@/helpers/enums';
import { GameCardFactory, ShowAllGameCard } from '@/modules/game/components';
import { ScLobbyGamesSlide } from './styled';

export type PlugType = Record<never, never>;

export interface LobbyGamesSlideProps
  extends Pick<ScGameItemPlugProps, 'plugBlack'> {
  games?: GameV1[];
  link?: string;
  rows: number;
  cols: number;
  gameItemMode?: GameItemMode;
  blackShowAllCard?: boolean;
  gameColorMode?: ColorMode;
  plugs: PlugType[];
}

export const Slide: FC<LobbyGamesSlideProps> = ({
  games,
  link,
  rows,
  cols,
  plugs,
  gameColorMode,
}) => {
  const slideGames = useMemo(
    () => (link ? games?.slice(0, games.length - 1) : games) || [],
    [games, link]
  );

  const mode = gameColorMode === ColorMode.GRAY_BG ? 'black' : 'dark';
  return (
    <ScLobbyGamesSlide cols={cols} rows={rows}>
      {slideGames.map((game) => (
        <GameCardFactory game={game} key={game.id} />
      ))}
      {plugs.map((_, index) => (
        <GameCardFactory
          isEmpty
          isEveryEmpty={slideGames.length === 0}
          key={`empty-${index}`}
          mode={mode}
        />
      ))}
      {link && <ShowAllGameCard isShowAll mode={mode} to={link} />}
    </ScLobbyGamesSlide>
  );
};
